import {
    AssociationRead,
    AssociationReadWReferenceLoad,
    AssociationUpdate,
    Group,
    JobRead,
    PersonCredibility,
    TagCreate,
    TagRead,
    TagResults,
} from "../schemas";
import {apiFetch} from "./client";

export async function getTagsByIds(ids?: string[], groupId?: string | null): Promise<TagRead[]> {
    if (!groupId && !ids) return []; // No group and no specific IDs — nothing to fetch
    const params: Record<string, unknown> = {};
    if (groupId) params.group_id = groupId;
    if (ids) params.ids = ids;
    const resp = await apiFetch<TagResults>("/tags/get_tags", {params});
    return resp.tags;
}

export async function getTags(groupId?: string | null): Promise<TagRead[]> {
    return getTagsByIds(undefined, groupId);
}

export async function createTags(tags: TagCreate[]): Promise<TagRead[]> {
    return apiFetch<TagRead[]>("/tags/create_tags", {method: "POST", body: tags});
}

export async function deleteTag(tag_id: string): Promise<TagRead> {
    return apiFetch<TagRead>(`/tags/${tag_id}`, {
        method: "DELETE",
        params: {id: tag_id},
    });
}

export async function queueTagInference(tagIds: string[]): Promise<JobRead> {
    return apiFetch<JobRead>("/tags/queue_tag_inference", {
        method: "POST",
        body: {tag_ids: tagIds},
    });
}

export async function applyTag(
    tag_id: string,
    operatorLabeled: boolean,
    newScore: number,
    doc_id: string,
    current_group: Group,
): Promise<AssociationRead | null> {
    console.log(current_group.review_round);
    const associationData = {
        tag_id,
        doc_id,
        operator_labeled: operatorLabeled,
        score: newScore,
    } as AssociationUpdate;
    return apiFetch<AssociationRead>("/tags/update_association", {
        method: "POST",
        body: associationData,
    });
}

export async function getAssociations(docId: string): Promise<AssociationRead[]> {
    const resp = await apiFetch<{ associations: AssociationRead[] }>("/tags/get_associations", {
        params: {doc_id: docId},
    });
    return resp.associations;
}

export async function getAssociationsWithReferences(
    docIds: string[],
    tagId: string,
): Promise<AssociationReadWReferenceLoad[]> {
    const resp = await apiFetch<{ associations: AssociationReadWReferenceLoad[] }>(
        "/tags/get_associations_with_references",
        {params: {doc_ids: docIds, tag_id: tagId}},
    );
    return resp.associations;
}

/** Fetch credibility profiles for a list of person tags. */
export async function getWitnessCredibility(
    tagIds: string[],
): Promise<Record<string, PersonCredibility>> {
    if (tagIds.length === 0) return {};
    const resp = await apiFetch<{ profiles: Record<string, PersonCredibility> }>(
        "/tags/credibility",
        {method: "POST", body: {tag_ids: tagIds}},
    );
    return resp.profiles;
}
